import React from 'react'
import SortUpload from './index'
import Selecter from './Selecter'
import styles from './style.module.less'

export default ({
  value,
  max,
  maxSize,
  maxHeight,
  maxWidth,
  onChange,
  onLoad,
  selectMode = false,
  selected = [],
  onSelect = () => {}
}) => {
  return (
    <div className={styles.areaList}>
      {selectMode && (
        <Selecter value={value} selected={selected} onSelect={onSelect} />
      )}
      {!selectMode && (
        <SortUpload
          value={value}
          max={max}
          maxSize={maxSize}
          maxHeight={maxHeight}
          maxWidth={maxWidth}
          onChange={onChange}
          onLoad={onLoad}
        />
      )}
    </div>
  )
}
